import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Subtitle, Button } from '../../constants/base';
import {
  TitleField,
  TextField,
  Form,
  Anchor,
  ErrorText,
} from './PassReset.styled';
import { confirmResetPassword } from '../../api/users';
import { getToken } from '../../services/auth';

export const ConfirmPassReset = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formSent, setFormSent] = useState(false);
  const [searchParams] = useSearchParams();

  const [values, setValues] = React.useState({
    newPassword1: '',
    newPassword2: '',
    showPassword1: false,
    showPassword2: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword1 = () => {
    setValues({ ...values, showPassword1: !values.showPassword1 });
  };

  const handleClickShowPassword2 = () => {
    setValues({ ...values, showPassword2: !values.showPassword2 });
  };

  const [error, setError] = useState({
    newPassword1: [],
    newPassword2: [],
    nonFieldErrors: [],
  });

  const onSubmit = async (event) => {
    event.preventDefault();

    try {
      await confirmResetPassword({
        token: getToken(),
        params: {
          newPassword1: event.target.newPassword1.value,
          newPassword2: event.target.newPassword2.value,
          uid: searchParams.get('uid'),
          token: searchParams.get('token'),
        },
      });
      setFormSent(true);
      window.setTimeout(function () {
        navigate('/', { replace: true });
      }, 4000);
    } catch (err) {
      const errData = err.response.data;
      if (err.response.status === 400) {
        setError({
          newPassword1: errData.newPassword1 || [],
          newPassword2: errData.newPassword2 || [],
          nonFieldErrors: errData.nonFieldErrors || [],
        });
        return;
      }
      throw new Error(err);
    }
  };

  return (
    <>
      <Subtitle>{t('PasswordResetConfirm.formRight.subTitle')}</Subtitle>
      <TitleField>
        {t('PasswordResetConfirm.form.titleField.description')}
      </TitleField>
      <Form onSubmit={onSubmit}>
        <TextField
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword1}
                  edge="end">
                  {values.showPassword1 ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          type={values.showPassword1 ? 'text' : 'password'}
          value={values.newPassword1}
          onChange={handleChange('newPassword1')}
          error={error.newPassword1.length}
          helperText={error.newPassword1[0]}
          label={t('PasswordChange.newPassword1.label')}
          placeholder={t('PasswordChange.newPassword1.placeholder')}
          name="newPassword1"
          variant="outlined"
          size="small"
          required
        />
        <TextField
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword2}
                  edge="end">
                  {values.showPassword2 ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          type={values.showPassword2 ? 'text' : 'password'}
          value={values.newPassword2}
          onChange={handleChange('newPassword2')}
          error={error.newPassword2.length}
          helperText={error.newPassword2[0]}
          label={t('PasswordChange.newPassword1.label')}
          placeholder={t('PasswordChange.newPassword1.placeholder')}
          name="newPassword2"
          variant="outlined"
          size="small"
          required
        />
        {error.nonFieldErrors.length > 0 && (
          <ErrorText>{error.nonFieldErrors[0]}</ErrorText>
        )}
        {formSent && (
          <Alert severity="success">
            <AlertTitle>
              {t('PasswordResetConfirm.form.alert.success')}
            </AlertTitle>
          </Alert>
        )}
        <Button type="submit">{t('PasswordChange.cta')}</Button>
        <Anchor to="/">{t('PasswordReset.form.anchor.backLogin')}</Anchor>
      </Form>
    </>
  );
};
